import { render, staticRenderFns } from "./NewSupply.vue?vue&type=template&id=dfc04234&scoped=true&"
import script from "./NewSupply.vue?vue&type=script&lang=js&"
export * from "./NewSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc04234",
  null
  
)

export default component.exports